<template>
 <div>
   <nav>
    <page-header />
  </nav>
  <router-view/>
  <Footer/>
 </div>
</template>

<script>
import PageHeader from './components/PageHeader.vue'
import Footer from "@/components/Footer.vue"
export default {
  components: { PageHeader, Footer },
  
}
</script>
<style>
</style>
